/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLambda = createReactComponent("outline", "lambda", "IconLambda", [["path", { "d": "M6 20l6.5 -9", "key": "svg-0" }], ["path", { "d": "M19 20c-6 0 -6 -16 -12 -16", "key": "svg-1" }]]);

export { IconLambda as default };
//# sourceMappingURL=IconLambda.mjs.map
